import ListContent from 'components/ListContent/ListContent';
import ListMenu from 'components/ListMenu/ListMenu';
import ListNav from 'components/ListNav/ListNav';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import * as React from 'react';
import styled from 'styled-components';

export interface IList {
  title: string;
  content: string;
}

export interface IListProps {
  index: number;
  changeItem: (index: number) => void;
}

interface IProps {
  items: IList[];
  opacity: boolean;
  background: string;
  menu: {
    background: string;
    color: string;
    activeColor: string;
  };
}

type Props = IProps & IListProps & IWithCountryProps & WithColorQueryProps;

export const List: React.SFC<Props> = props => {
  const currentItem = props.items[props.index];
  return (
    <Container>
      <LeftMost style={{ background: props.background }} />
      <Center>
        <ListMenu
          {...props.menu}
          changeItem={props.changeItem}
          index={props.index}
          titles={props.items.map(item => item.title)}
        />
        <Right>
          <RightContainer>
            <ListContent opacity={props.opacity} item={currentItem} />
            <ListNav
              index={props.index}
              changeItem={props.changeItem}
              items={props.items}
            />
          </RightContainer>
        </Right>
      </Center>
      <RightMost />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  min-height: 60vh;
  @media (max-width: 900px) {
    min-height: initial;
    flex-direction: column;
  }
`;

const Right = styled.div`
  display: flex;
  flex: 1;
`;

const RightContainer = styled.div`
  display: flex;
  height: fit-content;
  flex: 1;
`;

const LeftMost = styled.div`
  flex: 1 1 auto;
`;

const RightMost = styled.div`
  flex: 1 1 auto;
`;

const Center = styled.div`
  flex: 1 1 1100px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 900px) {
    flex-direction: column;
    flex: 1 1 auto;
  }
`;

export default withCountry(withColorQuery(List));



// WEBPACK FOOTER //
// ./src/components/List/List.tsx